import React from "react";

const Loader = (loader) =>{
    return (
        <>
        {loader.loader ? <>
        <div className="loader_parent">
            <span className="loader"></span>
        </div>
        </>:<></>}
        </>
    )
}
export default Loader;